import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import { API_ENDPOINTS, DEFAULT_PAGE_START } from '../Utils/constants'
import { generateFormData } from '../Utils/helpers'

export default class RevenueStore extends FetchBase {
  @observable ordering = undefined
  @observable orderingBy = undefined

  @observable innerOrdering = undefined
  @observable innerOrderingBy = undefined

  @observable innerMostOrdering = undefined
  @observable innerMostOrderingBy = undefined

  @observable inActiveordering = undefined
  @observable inActiveorderingBy = undefined

  @observable inActiveinnerOrdering = undefined
  @observable inActiveinnerOrderingBy = undefined

  @observable inActiveinnerMostOrdering = undefined
  @observable inActiveinnerMostOrderingBy = undefined

  @observable activeRevenueSearchText = ''
  @observable inActiveRevenueSearchText = ''

  @observable revenueFilterActive = {}
  @observable revenueFilterInActive = {}

  @observable activeMin = []
  @observable activeMax = []
  @observable inactiveMin = []
  @observable inactiveMax = []

  @observable totalRevenue = 0
  @observable totalinActiveRevenue = 0

  @observable mediaCentricUsersLoader = true

  @observable revenueData = []
  @observable inActiverevenueData = []

  @observable revenueActivePageNo = DEFAULT_PAGE_START
  @observable revenueInActiveUsersPageNo = DEFAULT_PAGE_START

  @observable lifetimeActiveRevenue = 0
  @observable lifetimeInActiveRevenue = 0

  @action.bound
  setOrdering = (value = undefined) => {
    this.ordering = value
  }

  @action.bound
  setOrderingBy = (value = undefined) => {
    this.orderingBy = value
  }

  @action.bound
  setInnerOrdering = (value = undefined) => {
    this.innerOrdering = value
  }

  @action.bound
  setInnerOrderingBy = (value = undefined) => {
    this.innerOrderingBy = value
  }

  @action.bound
  setInnerMostOrdering = (value = undefined) => {
    this.innerMostOrdering = value
  }

  @action.bound
  setInnerMostOrderingBy = (value = undefined) => {
    this.innerMostOrderingBy = value
  }

  @action.bound
  setInactiveOrdering = (value = undefined) => {
    this.inActiveordering = value
  }

  @action.bound
  setInactiveOrderingBy = (value = undefined) => {
    this.inActiveorderingBy = value
  }

  @action.bound
  setInactiveInnerOrdering = (value = undefined) => {
    this.inActiveinnerOrdering = value
  }

  @action.bound
  setInactiveInnerOrderingBy = (value = undefined) => {
    this.inActiveinnerOrderingBy = value
  }

  @action.bound
  setInactiveInnerMostOrdering = (value = undefined) => {
    this.inActiveinnerMostOrdering = value
  }

  @action.bound
  setInactiveInnerMostOrderingBy = (value = undefined) => {
    this.inActiveinnerMostOrderingBy = value
  }

  @action.bound
  SetRevenueActivePageNo = (value = DEFAULT_PAGE_START) => {
    this.revenueActivePageNo = value
  }

  @action.bound
  SetRevenueInActivePageNo = (value = DEFAULT_PAGE_START) => {
    this.revenueInActiveUsersPageNo = value
  }

  @action.bound
  setRevenueFilterActive = (values = {}) => {
    this.revenueFilterActive = values
  }

  @action.bound
  setRevenueFilterInActive = (values = {}) => {
    this.revenueFilterInActive = values
  }

  @action.bound
  setActiveRevenueSearchText = (value = '') => {
    this.activeRevenueSearchText = value
  }

  @action.bound
  setInActiveRevenueSearchText = (value = '') => {
    this.inActiveRevenueSearchText = value
  }

  @action.bound
  generateActiveRevenueFilters = () => {
    let tempGenerateRevenueFilters = {}

    let keys = Object.keys(this.revenueFilterActive || {})
    for (let filter of keys) {
      if (this.revenueFilterActive[filter] !== undefined) {
        tempGenerateRevenueFilters[filter] = this.revenueFilterActive[filter]
      }
    }
    this.activeRevenueSearchText &&
      (tempGenerateRevenueFilters['search'] = this.activeRevenueSearchText)
    this.ordering && (tempGenerateRevenueFilters['ordering'] = this.ordering)
    this.ordering && (tempGenerateRevenueFilters['orderBy'] = this.orderingBy)

    this.innerOrdering &&
      (tempGenerateRevenueFilters['organizationOrdering'] = this.innerOrdering)
    this.innerOrdering &&
      (tempGenerateRevenueFilters['organizationOrderBy'] = this.innerOrderingBy)

    this.innerMostOrdering &&
      (tempGenerateRevenueFilters['transactionOrdering'] =
        this.innerMostOrdering)
    this.innerMostOrdering &&
      (tempGenerateRevenueFilters['transactionOrderBy'] =
        this.innerMostOrderingBy)

    return tempGenerateRevenueFilters
  }

  @action.bound
  generateInactiveRevenueFilters = () => {
    let tempGenerateRevenueFilters = {}

    let keys = Object.keys(this.revenueFilterInActive || {})
    for (let filter of keys) {
      if (this.revenueFilterInActive[filter] !== undefined) {
        tempGenerateRevenueFilters[filter] = this.revenueFilterInActive[filter]
      }
    }
    this.inActiveRevenueSearchText &&
      (tempGenerateRevenueFilters['search'] = this.inActiveRevenueSearchText)
    this.inActiveordering &&
      (tempGenerateRevenueFilters['ordering'] = this.inActiveordering)
    this.inActiveordering &&
      (tempGenerateRevenueFilters['orderBy'] = this.inActiveorderingBy)

    this.inActiveinnerOrdering &&
      (tempGenerateRevenueFilters['organizationOrdering'] =
        this.inActiveinnerOrdering)
    this.inActiveinnerOrdering &&
      (tempGenerateRevenueFilters['organizationOrderBy'] =
        this.inActiveinnerOrderingBy)

    this.inActiveinnerMostOrdering &&
      (tempGenerateRevenueFilters['transactionOrdering'] =
        this.inActiveinnerMostOrdering)
    this.inActiveinnerMostOrdering &&
      (tempGenerateRevenueFilters['transactionOrderBy'] =
        this.inActiveinnerMostOrderingBy)

    return tempGenerateRevenueFilters
  }

  @action.bound
  getFilters = () => {
    let tempgetFilters = {}
    if (this.ordering) {
      tempgetFilters['ordering'] = this.ordering
      tempgetFilters['orderBy'] = this.orderingBy
    }
    return tempgetFilters
  }

  @action.bound
  revenueActiveExport = async (value, { exportFileType = 'csv' } = {}) => {
    try {
      let options = this.generateActiveRevenueFilters()
      options['exportFileType'] = exportFileType
      let response = await this.post(API_ENDPOINTS.EXPORT_RESELLER, {
        isActiveOrg: true,
        revenue: true,
        resellerId: value,
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  revenueInactiveExport = async (value, { exportFileType = 'csv' } = {}) => {
    try {
      let options = this.generateInactiveRevenueFilters()
      options['exportFileType'] = exportFileType
      let response = await this.post(API_ENDPOINTS.EXPORT_RESELLER, {
        isActiveOrg: false,
        revenue: true,
        resellerId: value,
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  revenueActiveList = async (value, signal) => {
    try {
      this.mediaCentricUsersLoader = true

      let options = this.generateActiveRevenueFilters() || {}
      options['pageNo'] = Math.max(this.revenueActivePageNo - 1, 0)

      this.activeRevenueSearchText &&
        (options['search'] = this.activeRevenueSearchText)

      let response = await this.post(
        API_ENDPOINTS.GET_RESELLER_DATA,
        {
          isActiveOrg: true,
          revenue: true,
          resellerId: value,
          ...options,
        },
        signal
      )
      if (response.status) {
        this.revenueData = response.data?.resellerDetails
        this.totalRevenue = response.data?.resellerDetails.length - 2
        this.activeMin = response.data?.min
        this.activeMax = response.data?.max
        this.lifetimeActiveRevenue =
          response?.data?.resellerDetails[
            response?.data?.resellerDetails.length - 1
          ].resellerLifeTimeTotalCommission
        return true
      }
      this.revenueData = []

      return false
    } catch (err) {
      this.revenueData = []

      return false
    } finally {
      this.mediaCentricUsersLoader = false
    }
  }

  @action.bound
  revenueInActiveList = async (value, signal) => {
    try {
      this.mediaCentricUsersLoader = true
      let options = this.generateInactiveRevenueFilters() || {}
      options['pageNo'] = Math.max(this.revenueInActiveUsersPageNo - 1, 0)
      this.inActiveRevenueSearchText &&
        (options['search'] = this.inActiveRevenueSearchText)
      let response = await this.post(
        API_ENDPOINTS.GET_RESELLER_DATA,
        {
          isActiveOrg: false,
          revenue: true,
          resellerId: value,
          ...options,
        },
        signal
      )
      if (response.status) {
        this.inActiverevenueData = response.data?.resellerDetails
        this.totalinActiveRevenue = response.data?.resellerDetails.length - 2
        this.inactiveMin = response.data?.min
        this.inactiveMax = response.data?.max
        this.lifetimeInActiveRevenue =
          response?.data?.resellerDetails[
            response?.data?.resellerDetails.length - 1
          ].resellerLifeTimeTotalCommission
        return true
      }
      this.inActiverevenueData = []

      return false
    } catch (err) {
      this.inActiverevenueData = []

      return false
    } finally {
      this.mediaCentricUsersLoader = false
    }
  }

  @action.bound
  resetFilterForm = () => {
    this.revenueFilterActive = {}
    this.revenueFilterInActive = {}
  }

  @action.bound
  resetStore = () => {
    this.activeRevenueSearchText = ''
    this.inActiveRevenueSearchText = ''
    this.revenueFilterActive = {}
    this.revenueFilterInActive = {}
    this.revenueData = []
    this.revenueActivePageNo = DEFAULT_PAGE_START
    this.revenueInActiveUsersPageNo = DEFAULT_PAGE_START
    this.revenuetransactionsData = []
    this.totalRevenue = 0
    this.totalinActiveRevenue = 0
    this.lifetimeActiveRevenue = 0
    this.lifetimeInActiveRevenue = 0
    this.mediaCentricUsersLoader = true

    this.activeMin = []
    this.activeMax = []
    this.inactiveMin = []
    this.inactiveMax = []

    this.ordering = undefined
    this.orderingBy = undefined

    this.innerOrdering = undefined
    this.innerOrderingBy = undefined

    this.innerMostOrdering = undefined
    this.innerMostOrderingBy = undefined

    this.inActiveordering = undefined
    this.inActiveorderingBy = undefined

    this.inActiveinnerOrdering = undefined
    this.inActiveinnerOrderingBy = undefined

    this.inActiveinnerMostOrdering = undefined
    this.inActiveinnerMostOrderingBy = undefined
  }
}
